<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="用户申请id" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userApplyId">
              <a-input v-model="model.userApplyId" placeholder="请输入用户申请id"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="申请使用应用id" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationId">
              <a-input v-model="model.applicationId" placeholder="请输入申请使用应用id"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="用户审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auditStatus">
              <a-input v-model="model.auditStatus" placeholder="请输入用户审核状态"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="审核时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auditTime">
              <j-date placeholder="请选择审核时间" v-model="model.auditTime" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="审核人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auditor">
              <a-input v-model="model.auditor" placeholder="请输入审核人"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="审核意见" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auditRemark">
              <a-input v-model="model.auditRemark" placeholder="请输入审核意见"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import {httpAction, getAction} from '@/api/manage'
  import {validateDuplicateValue} from '@/utils/util'

  export default {
    name: 'SysUserApplyAuditForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: {},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        confirmLoading: false,
        validatorRules: {
          userApplyId: [
            {required: true, message: '请输入用户申请id!'},
          ],
          applicationId: [
            {required: true, message: '请输入申请使用应用id!'},
          ],
          auditStatus: [
            {required: true, message: '请输入用户审核状态!'},
          ],
        },
        url: {
          add: "/com/sysUserApplyAudit/add",
          edit: "/com/sysUserApplyAudit/edit",
          queryById: "/com/sysUserApplyAudit/queryById"
        }
      }
    },
    computed: {
      formDisabled() {
        return this.disabled
      },
    },
    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add() {
        this.edit(this.modelDefault);
      },
      edit(record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>